export const getAllUsers = '/users';
export const getUserDetail = '/users/';
export const addVendor = '/users/create-vendor-user';
export const addAdmin = '/users/create-admin-user';
export const addUserAddress = '/address/addAddress';
export const updateUser = '/users/';
export const addMaster = '/users/create-master-user';
export const updateUserStatus = '/users/update-status/';
